"use strict";

import { NgModule } from "@angular/core";

import { UserListsService } from "./user-lists.service";

@NgModule({
    providers: [UserListsService]
})
export class UserListsModule {}